// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"03c237cd","425":"a4dc0c1f","432":"9932aaeb","453":"c3140a2e"}[chunkId] + ".chunk.js";
};